export default __webpack_public_path__ + "static/media/341578__kimp10__success.ceacdea8.mp3";